(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-curtain-cro"]) return;
  try {
    
(() => {
  if (window.__curtainCroAddonBound) return;
  window.__curtainCroAddonBound = true;

  const getRoot = (element) => element && element.closest('product-info.curtain-cro-mode--matching_sheer');

  const setAddonState = (root, selected) => {
    if (!root) return;

    const button = root.querySelector('[data-cro-addon-toggle]');
    const addonAvailable =
      !!button &&
      !button.disabled &&
      Number(button.dataset.sheerVariantId || 0) > 0;

    // Never keep an unavailable matching sheer logically selected.
    selected = Boolean(selected && addonAvailable);

    if (!selected) {
      // Re-adding should always begin from one explicit piece.
      root.dataset.croSheerQuantity = '1';
    } else if (!root.dataset.croSheerQuantity) {
      root.dataset.croSheerQuantity = '1';
    }

    const sheerQuantity = Math.max(1, Number(root.dataset.croSheerQuantity || 1));
    root.dataset.croSheerSelected = selected ? 'true' : 'false';

    if (button) {
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.textContent = selected ? button.dataset.selectedLabel : button.dataset.unselectedLabel;
    }

    const qtyControl = root.querySelector('[data-cro-sheer-qty-control]');
    if (qtyControl) qtyControl.hidden = !selected;

    const qtyValue = root.querySelector('[data-cro-sheer-qty-value]');
    if (qtyValue) qtyValue.textContent = String(sheerQuantity);

    const summary = root.querySelector('[data-cro-selection-summary]');
    if (summary) summary.hidden = !selected;

    const summaryText = root.querySelector('[data-cro-selection-summary-text]');
    if (summaryText) {
      const blackoutLabel =
        (summary && summary.dataset.blackoutLabel) || 'Blackout';
      summaryText.textContent =
        blackoutLabel +
        ' + ' +
        sheerQuantity +
        ' Matching Sheer' +
        (sheerQuantity === 1 ? '' : 's') +
        ' selected';
    }

    root.dispatchEvent(new CustomEvent('cro:sheer-change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const qtyMinus = event.target.closest('[data-cro-sheer-qty-minus]');
    const qtyPlus = event.target.closest('[data-cro-sheer-qty-plus]');

    if (qtyMinus || qtyPlus) {
      const root = getRoot(qtyMinus || qtyPlus);
      if (!root) return;

      event.preventDefault();

      let quantity = Math.max(1, Number(root.dataset.croSheerQuantity || 1));
      if (qtyMinus) quantity = Math.max(1, quantity - 1);
      if (qtyPlus) quantity += 1;

      root.dataset.croSheerQuantity = String(quantity);
      setAddonState(root, true);
      return;
    }

    const button = event.target.closest('[data-cro-addon-toggle]');
    if (!button) return;

    const root = getRoot(button);
    if (!root || button.disabled) return;

    event.preventDefault();
    setAddonState(root, button.getAttribute('aria-pressed') !== 'true');
  });

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const root = getRoot(form);
      if (!root || root.dataset.croSheerSelected !== 'true') return;

      const productForm = form.closest('product-form');
      const addonButton = root.querySelector('[data-cro-addon-toggle]');
      const submitButton = productForm && productForm.querySelector('[type="submit"]');
      const spinner = productForm && productForm.querySelector('.loading__spinner');

      const sheerVariantId = Number((addonButton && addonButton.dataset.sheerVariantId) || 0);
      const sheerQuantity = Math.max(1, Number(root.dataset.croSheerQuantity || 1));
      const mainVariantInput = form.querySelector('[name="id"]');
      const mainVariantId = Number((mainVariantInput && mainVariantInput.value) || 0);

      const formData = new FormData(form);
      const quantityInput = root.querySelector('.quantity__input');
      const mainQuantity = Math.max(
        1,
        Number(formData.get('quantity') || (quantityInput && quantityInput.value) || 1)
      );

      if (!sheerVariantId || !sheerQuantity || !mainVariantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const payload = {
        items: [
          { id: mainVariantId, quantity: mainQuantity },
          { id: sheerVariantId, quantity: sheerQuantity }
        ]
      };

      if (cart && cart.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      try {
        const fallbackRoot =
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const addUrl = fallbackRoot + 'cart/add.js';

        const requestConfig =
          typeof fetchConfig === 'function'
            ? fetchConfig()
            : {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                }
              };

        requestConfig.headers = requestConfig.headers || {};
        requestConfig.headers['Content-Type'] = 'application/json';
        requestConfig.headers.Accept = 'application/json';
        requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        requestConfig.body = JSON.stringify(payload);

        const response = await fetch(addUrl, requestConfig);
        const responseText = await response.text();

        let data = {};
        try {
          data = responseText ? JSON.parse(responseText) : {};
        } catch (parseError) {
          console.error('Curtain CRO cart response was not JSON:', responseText);
          throw parseError;
        }

        if (!response.ok || data.status) {
          const message =
            data.description ||
            data.message ||
            data.errors ||
            'Unable to add the selected curtains to cart.';
          if (productForm && productForm.handleErrorMessage) {
            productForm.handleErrorMessage(
              typeof message === 'string' ? message : 'Unable to add the selected curtains to cart.'
            );
          }
          return;
        }

        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'curtain-cro-addon',
            productVariantId: mainVariantId,
            cartData: data
          });
        }

        if (cart && cart.renderContents && data.sections) {
          try {
            cart.renderContents(data);
          } catch (renderError) {
            // The items have already been added successfully. If a cart UI
            // renderer cannot consume a multi-item response, show the real cart
            // instead of reporting a false add-to-cart failure.
            console.error('Curtain CRO cart UI render failed:', renderError);
            const cartUrl =
              (window.routes && window.routes.cart_url) || fallbackRoot + 'cart';
            window.location = cartUrl;
          }
        } else {
          const cartUrl =
            (window.routes && window.routes.cart_url) || fallbackRoot + 'cart';
          window.location = cartUrl;
        }
      } catch (error) {
        console.error(error);
        if (productForm && productForm.handleErrorMessage) {
          productForm.handleErrorMessage(
            'Unable to add the selected curtains to cart. Please try again.'
          );
        }
      } finally {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      }
    },
    true
  );

  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const sectionId = data && data.sectionId;
      const html = data && data.html;
      if (!sectionId || !html) return;

      const selector = 'product-info[data-section="' + sectionId + '"]';
      const root = document.querySelector(selector);
      const sourceRoot = html.querySelector(selector);
      if (!root || !sourceRoot) return;

      if (root.classList.contains('curtain-cro-mode--matching_sheer')) {
        const wasSelected = root.dataset.croSheerSelected === 'true';
        const wasQuantity = Math.max(1, Number(root.dataset.croSheerQuantity || 1));
        const sourceAddon = sourceRoot.querySelector('.curtain-cro__addon-wrap');
        const liveAddon = root.querySelector('.curtain-cro__addon-wrap');

        if (sourceAddon && liveAddon) {
          liveAddon.innerHTML = sourceAddon.innerHTML;
          root.dataset.croSheerQuantity = String(wasQuantity);
          setAddonState(root, wasSelected);
        }
      }

      if (root.classList.contains('curtain-cro-mode--set_bundle')) {
        [
          '.curtain-cro__hero-price',
          '.curtain-cro__choice--blackout .curtain-cro__choice-price',
          '.curtain-cro__choice--complete .curtain-cro__price-row',
          '.curtain-cro__single-panel'
        ].forEach((selectorText) => {
          const liveNode = root.querySelector(selectorText);
          const sourceNode = sourceRoot.querySelector(selectorText);
          if (liveNode && sourceNode) liveNode.innerHTML = sourceNode.innerHTML;
        });
      }
    });
  }

  const initializeNativeSticky = () => {
    const sticky = document.querySelector('[data-cro-native-sticky]');
    if (!sticky || sticky.dataset.croInitialized === 'true') return;
    sticky.dataset.croInitialized = 'true';

    const sectionId = sticky.dataset.sectionId;
    const root = document.querySelector('product-info[data-section="' + sectionId + '"]');
    if (!root) return;

    const stickySubmit = sticky.querySelector('[data-cro-native-sticky-submit]');
    const stickyPrice = sticky.querySelector('[data-cro-native-sticky-price]');
    const stickySize = sticky.querySelector('[data-cro-native-sticky-size]');
    const variantMapNode = sticky.querySelector('[data-cro-native-variant-map]');
    if (!stickySubmit || !stickyPrice || !stickySize || !variantMapNode) return;

    let variantMap = [];
    try {
      variantMap = JSON.parse(variantMapNode.textContent || '[]');
    } catch (error) {
      variantMap = [];
    }

    const getMainSubmit = () => root.querySelector('product-form [type="submit"]');
    const getMainVariantInput = () => root.querySelector('product-form input[name="id"]');
    const getMainVariantId = () => String((getMainVariantInput() && getMainVariantInput().value) || '');

    const normalizeOptionValue = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/×/g, 'x')
        .replace(/\s+/g, '')
        .trim();

    const getSelectedOptionValues = () => {
      const picker = root.querySelector('variant-selects');
      if (!picker) return [];

      const values = [];
      picker.querySelectorAll('.product-form__input').forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        const select = group.querySelector('select');
        const value = checked ? checked.value : select ? select.value : '';
        if (value) values.push(value);
      });
      return values;
    };

    const findVariantFromCurrentPicker = () => {
      const selected = getSelectedOptionValues().map(normalizeOptionValue);
      if (!selected.length) return null;

      return (
        variantMap.find((entry) => {
          const options = Array.isArray(entry.options) ? entry.options.map(normalizeOptionValue) : [];
          return options.length === selected.length && options.every((value, index) => value === selected[index]);
        }) || null
      );
    };

    const findVariantById = (id) =>
      variantMap.find((entry) => String(entry.id || '') === String(id || '')) || null;

    const getMainQuantity = () => {
      const quantityInput = root.querySelector('.quantity__input');
      return Math.max(1, Number((quantityInput && quantityInput.value) || 1));
    };

    const formatStickyMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    };

    const getStickyDisplayPriceCents = () => {
      const mainQuantity = getMainQuantity();
      const blackoutCents = Number(stickyPrice.dataset.blackoutCents || 0);

      if (sticky.dataset.mode === 'variant_set') {
        return Number(root.dataset.croSelectedPriceCents || blackoutCents * mainQuantity);
      }

      if (sticky.dataset.mode === 'matching_sheer') {
        const selected = root.dataset.croSheerSelected === 'true';
        const blackoutTotal = blackoutCents * mainQuantity;

        if (!selected) return blackoutTotal;

        const sheerCents = Number(stickyPrice.dataset.sheerCents || 0);
        const sheerQuantity = Math.max(1, Number(root.dataset.croSheerQuantity || 1));
        return blackoutTotal + sheerCents * sheerQuantity;
      }

      if (sticky.dataset.mode === 'set_bundle' && root.querySelector('[data-cro-bundle-size]')) {
        if (root.dataset.croPurchaseMode === 'single') {
          return Number(root.dataset.croSingleTotalCents || 0);
        }
        const selected = root.querySelector('[id^="CroSheerPair-"]:checked, [id^="CroCompleteSet-"]:checked, [id^="CroBlackoutPair-"]:checked');
        const selectedVariant = selected && variantMap.find((entry) => {
          const title = String(entry.title || '').toLowerCase().replace(/\s/g, '');
          const size = root.querySelector('[data-cro-bundle-size]:checked');
          const length = size ? size.value : '7';
          const option = selected.id.includes('SheerPair') ? 'sheerpair' :
            selected.id.includes('CompleteSet') ? 'setof4' : 'blackoutpair';
          return title.includes('4x' + length) && title.includes(option);
        });
        return Number(selectedVariant && selectedVariant.blackoutCents || blackoutCents) * mainQuantity;
      }

      const completeInput = root.querySelector('[id^="CroCompleteSet-"]');
      const selectedSetCents = Number(
        completeInput && completeInput.checked
          ? stickyPrice.dataset.completeCents
          : stickyPrice.dataset.blackoutCents
      ) || 0;

      return selectedSetCents * mainQuantity;
    };

    const updateStickyPrice = () => {
      stickyPrice.textContent = formatStickyMoney(getStickyDisplayPriceCents());
    };

    const normalizeStickySize = (title) => {
      if (!title || title === 'Default Title') return '';

      return String(title)
         .replace(/\s*\(\s*(?:set\s*of\s*2|set\s*of\s*4|blackout\s*pair|sheer\s*pair)\s*\)\s*/ig, '')
        .replace(/\s*\(\s*1\s*piece\s*\)\s*/ig, '')
        .replace(/(\d)\s*x\s*(\d)/ig, '$1×$2')
        .trim();
    };

    const updateStickyCtaLabel = () => {
      if (sticky.dataset.mode === 'variant_set') {
        const count = Number(root.dataset.croSingleCount || 0);
        stickySubmit.textContent = root.dataset.croPurchaseMode === 'single'
          ? count ? 'ADD ' + count + ' ' + (count === 1 ? 'PIECE' : 'PIECES') + ' TO CART' : 'SELECT PIECES'
          : 'ADD TO CART';
        return;
      }
      const hasMatchingSheer =
        sticky.dataset.mode === 'matching_sheer' &&
        root.dataset.croSheerSelected === 'true';

      if (sticky.dataset.mode === 'set_bundle' && root.dataset.croPurchaseMode === 'single') {
        const count = Number(root.dataset.croSingleCount || 0);
        stickySubmit.textContent = count
          ? 'ADD ' + count + ' ' + (count === 1 ? 'PIECE' : 'PIECES') + ' TO CART'
          : 'SELECT PIECES';
        return;
      }
      stickySubmit.textContent = hasMatchingSheer
        ? 'ADD SELECTED SET TO CART'
        : 'ADD TO CART';
    };

    const updateStickySize = () => {
      if (sticky.dataset.mode === 'variant_set') {
        stickySize.textContent = String(root.dataset.croSelectedLabel || '');
      } else if (sticky.dataset.mode === 'set_bundle') {
        const size = root.querySelector('[data-cro-bundle-size]:checked');
        const length = size ? size.value : '7';
        const count = Number(root.dataset.croSingleCount || 0);
        stickySize.textContent = '4×' + length + ' ft' + (
          root.dataset.croPurchaseMode === 'single' && count
            ? ' · ' + count + ' ' + (count === 1 ? 'piece' : 'pieces')
            : ''
        );
      } else {
        stickySize.textContent = normalizeStickySize(sticky.dataset.selectedSize || '');
      }
      updateStickyCtaLabel();
    };

    const applyMappedVariant = (mappedVariant) => {
      if (!mappedVariant) return;

      sticky.dataset.selectedSize = mappedVariant.title || '';
      sticky.dataset.selectedVariantId = String(mappedVariant.id || '');

      if (mappedVariant.blackoutCents != null) {
        stickyPrice.dataset.blackoutCents = String(mappedVariant.blackoutCents);
      }
      if (mappedVariant.sheerCents != null) {
        stickyPrice.dataset.sheerCents = String(mappedVariant.sheerCents);
      }

      const addonButton = root.querySelector('[data-cro-addon-toggle]');
      if (addonButton) {
        addonButton.dataset.sheerVariantId = mappedVariant.sheerVariantId
          ? String(mappedVariant.sheerVariantId)
          : '';
        addonButton.dataset.sheerUnitPriceCents = String(mappedVariant.sheerCents || 0);
        addonButton.disabled = !mappedVariant.sheerVariantId || mappedVariant.sheerAvailable === false;

        const addonPrice = root.querySelector('.curtain-cro__addon-price');
        if (addonPrice && mappedVariant.sheerCents) {
          addonPrice.textContent = formatStickyMoney(mappedVariant.sheerCents) + ' / piece';
        }

        if (root.dataset.croSheerSelected === 'true' && addonButton.disabled) {
          setAddonState(root, false);
        }
      }

      updateStickySize();
      updateStickyPrice();
    };

    let pendingVariantTimer = null;

    const waitForMainFormVariant = (variantId, attempt = 0) => {
      if (pendingVariantTimer) window.clearTimeout(pendingVariantTimer);

      if (getMainVariantId() === String(variantId || '')) {
        updateAvailability();
        return;
      }

      if (attempt >= 40) {
        const actualVariant = findVariantById(getMainVariantId());
        if (actualVariant) applyMappedVariant(actualVariant);
        updateAvailability();
        return;
      }

      pendingVariantTimer = window.setTimeout(
        () => waitForMainFormVariant(variantId, attempt + 1),
        50
      );
    };

    const updateAvailability = () => {
      const mainSubmit = getMainSubmit();
      if (sticky.dataset.mode === 'variant_set') {
        stickySubmit.disabled = root.dataset.croDraftPreview === 'true' ||
          root.dataset.croSingleAvailable !== 'true' || !mainSubmit || mainSubmit.disabled;
        return;
      }
      if (sticky.dataset.mode === 'set_bundle' && root.dataset.croPurchaseMode === 'single') {
        stickySubmit.disabled =
          root.dataset.croDraftPreview === 'true' ||
          Number(root.dataset.croSingleCount || 0) < 1 ||
          root.dataset.croSingleAvailable !== 'true' ||
          !mainSubmit ||
          mainSubmit.getAttribute('aria-disabled') === 'true';
        return;
      }
      stickySubmit.disabled =
        !mainSubmit ||
        mainSubmit.disabled ||
        mainSubmit.getAttribute('aria-disabled') === 'true';
    };

    const mainSubmit = getMainSubmit();
    if (!mainSubmit) return;

    const stickyTrigger = root.querySelector('.product__media-wrapper') || mainSubmit;
    const cartDrawer = document.querySelector('cart-drawer');
    let hasScrolledPastGallery = false;

    const updateStickyVisibility = () => {
      const drawerOpen = !!(cartDrawer && cartDrawer.classList.contains('active'));
      const designMode = !!(window.Shopify && Shopify.designMode);
      const shouldShow = (designMode || hasScrolledPastGallery) && !drawerOpen;

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.hidden = !shouldShow;
    };

    if (window.Shopify && Shopify.designMode) {
      updateStickyPrice();
      updateAvailability();
    }

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        hasScrolledPastGallery =
          !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateStickyVisibility();
      },
      { threshold: 0.01 }
    );

    visibilityObserver.observe(stickyTrigger);

    if (cartDrawer) {
      const drawerObserver = new MutationObserver(updateStickyVisibility);
      drawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    stickySubmit.addEventListener('click', () => {
      const liveMainSubmit = getMainSubmit();
      if (!liveMainSubmit || stickySubmit.disabled) return;
      liveMainSubmit.click();
    });

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (!target) return;

      if (target.closest('variant-selects')) {
        // The browser has already updated the checked/select state at this point,
        // so resolve the newly chosen variant locally instead of waiting for
        // Shopify's asynchronous section response.
        const mappedVariant = findVariantFromCurrentPicker();

        if (mappedVariant) {
          applyMappedVariant(mappedVariant);
          stickySubmit.disabled = true;
          waitForMainFormVariant(mappedVariant.id);
        }
        return;
      }

      // Quantity and CRO set choices are local state and can refresh immediately.
      if (
        target.matches('.quantity__input') ||
        target.matches('[id^="CroBlackoutPair-"], [id^="CroCompleteSet-"]')
      ) {
        updateStickyPrice();
        updateAvailability();
      }
    });

    root.addEventListener('input', (event) => {
      if (event.target && event.target.matches('.quantity__input')) {
        updateStickyPrice();
      }
    });

    root.addEventListener('click', (event) => {
      if (event.target && event.target.closest('.quantity__button')) {
        window.setTimeout(updateStickyPrice, 0);
      }
    });

    root.addEventListener('cro:sheer-change', () => {
      updateStickyPrice();
      updateStickyCtaLabel();
    });
    root.addEventListener('cro:bundle-change', () => {
      updateStickyPrice();
      updateStickySize();
      updateAvailability();
    });
    root.addEventListener('cro:variant-set-change', () => {
      updateStickyPrice();
      updateStickySize();
      updateAvailability();
    });

    const stateObserver = new MutationObserver(() => {
      updateStickyPrice();
      updateAvailability();
    });

    stateObserver.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-pressed', 'value']
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || data.sectionId !== sectionId) return;

        const confirmedVariant = data.variant;
        const mappedVariant = confirmedVariant && findVariantById(confirmedVariant.id);

        if (mappedVariant) {
          applyMappedVariant(mappedVariant);
        }

        updateAvailability();
      });
    }

    const initialMappedVariant =
      findVariantById(getMainVariantId()) || findVariantFromCurrentPicker();

    if (initialMappedVariant) {
      applyMappedVariant(initialMappedVariant);
    } else {
      updateStickyPrice();
      updateStickySize();
    }
    updateAvailability();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNativeSticky, { once: true });
  } else {
    initializeNativeSticky();
  }

})();

(() => {
  const initSetChoice = () => {
    const root = document.querySelector('product-info.curtain-cro-mode--set_bundle');
    const mapNode = document.querySelector('[data-cro-native-variant-map]');
    if (!root || !mapNode || root.dataset.croBundleBound === 'true') return;
    root.dataset.croBundleBound = 'true';

    if (root.dataset.croDraftPreview === 'true') {
      const disableDraftPurchase = () => {
        root.querySelectorAll('product-form [type="submit"], [data-cro-single-kind]').forEach((button) => {
          if (!button.disabled) button.disabled = true;
        });
        const stickyButton = document.querySelector('[data-cro-native-sticky-submit]');
        if (stickyButton && !stickyButton.disabled) stickyButton.disabled = true;
      };
      disableDraftPurchase();
      new MutationObserver(disableDraftPurchase).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
      root.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }

    let variants = [];
    try { variants = JSON.parse(mapNode.textContent || '[]'); } catch (error) { return; }
    const complete = root.querySelector('[id^="CroCompleteSet-"]');
    const pair = root.querySelector('[id^="CroBlackoutPair-"]');
    const sheer = root.querySelector('[id^="CroSheerPair-"]');
    const sizes = Array.from(root.querySelectorAll('[data-cro-bundle-size]'));
    const singlePanel = root.querySelector('.curtain-cro__single');
    const form = root.querySelector('product-form form');
    const productForm = form && form.closest('product-form');
    const submit = form && form.querySelector('[type="submit"]');
    const submitLabel = submit && submit.querySelector('span');
    if (!pair || !sizes.length || !form || !submit) return;

    const money = (cents) => new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: 'INR', maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);
    const selectedLength = () => {
      const checked = sizes.find((input) => input.checked);
      return checked ? checked.value : '7';
    };
    const getVariant = (length, packageName) => variants.find((entry) => {
      const title = String(entry.title || '').toLowerCase().replace(/\s/g, '');
      return title.includes('4x' + length) && title.includes(packageName);
    });
    const currentComponents = () => getVariant(selectedLength(), 'blackoutpair') ||
      getVariant(selectedLength(), 'setof4') || null;
    const quantities = { blackout: 0, sheer: 0 };

    const updatePrices = () => {
      const length = selectedLength();
      const pairVariant = getVariant(length, 'blackoutpair');
      const sheerVariant = getVariant(length, 'sheerpair');
      const completeVariant = getVariant(length, 'setof4');
      const components = currentComponents();
      const setText = (selector, value) => {
        const node = root.querySelector(selector);
        if (node) node.textContent = value;
      };
      if (pairVariant) {
        setText('.curtain-cro__choice--blackout .curtain-cro__choice-price', money(pairVariant.blackoutCents));
        setText('.curtain-cro__hero-price--blackout strong', money(pairVariant.blackoutCents));
      }
      if (sheerVariant) {
        setText('.curtain-cro__choice--sheer .curtain-cro__choice-price', money(sheerVariant.blackoutCents));
        setText('.curtain-cro__hero-price--sheer strong', money(sheerVariant.blackoutCents));
      }
      if (completeVariant) {
        const price = Number(completeVariant.blackoutCents || 0);
        const regular = Number(completeVariant.regularCents || price);
        const discount = Math.max(0, regular - price);
        setText('.curtain-cro__choice--complete strong', money(price));
        setText('.curtain-cro__choice--complete s', money(regular));
        setText('.curtain-cro__choice--complete em', 'Save ' + money(discount));
        setText('.curtain-cro__hero-price--complete strong', money(price));
        setText('.curtain-cro__hero-price--complete s', money(regular));
        setText('.curtain-cro__hero-price--complete span', 'Save ' + money(discount));
      }
      if (components) {
        setText('[data-cro-single-blackout-price]', money(components.blackoutSingleCents));
        setText('[data-cro-single-sheer-price]', money(components.sheerSingleCents));
      }
    };

    const updateSelection = () => {
      const components = currentComponents();
      const count = quantities.blackout + quantities.sheer;
      const blackoutPrice = Number(components && components.blackoutSingleCents || 0);
      const sheerPrice = Number(components && components.sheerSingleCents || 0);
      const total = quantities.blackout * blackoutPrice + quantities.sheer * sheerPrice;
      const available = Boolean(
        components &&
        (!quantities.blackout || (components.blackoutSingleId && components.blackoutSingleAvailable)) &&
        (!quantities.sheer || (components.sheerSingleId && components.sheerSingleAvailable))
      );
      const singleMode = root.dataset.croPurchaseMode === 'single';
      root.dataset.croSingleCount = String(count);
      root.dataset.croSingleTotalCents = String(total);
      root.dataset.croSingleAvailable = available ? 'true' : 'false';

      ['blackout', 'sheer'].forEach((kind) => {
        const button = root.querySelector('[data-cro-single-kind="' + kind + '"]');
        const control = root.querySelector('[data-cro-single-control="' + kind + '"]');
        const value = root.querySelector('[data-cro-single-quantity="' + kind + '"]');
        const kindAvailable = Boolean(components &&
          components[kind + 'SingleId'] && components[kind + 'SingleAvailable']);
        if (button) {
          button.hidden = quantities[kind] > 0;
          button.disabled = root.dataset.croDraftPreview === 'true' || !kindAvailable;
        }
        if (control) control.hidden = quantities[kind] === 0;
        if (value) value.textContent = String(quantities[kind]);
      });

      const selection = root.querySelector('[data-cro-single-selection]');
      if (selection) selection.hidden = !singleMode || count === 0;
      const selectedParts = [];
      if (quantities.blackout) selectedParts.push(quantities.blackout + ' blackout panel' + (quantities.blackout === 1 ? '' : 's'));
      if (quantities.sheer) selectedParts.push(quantities.sheer + ' sheer panel' + (quantities.sheer === 1 ? '' : 's'));
      const summary = root.querySelector('[data-cro-single-selection-text]');
      if (summary) summary.textContent = selectedParts.join(' + ') + ' · 4 × ' + selectedLength() + ' ft';
      const summaryPrice = root.querySelector('[data-cro-single-selection-price]');
      if (summaryPrice) summaryPrice.textContent = 'Total: ' + money(total) + ' for ' + count + ' ' + (count === 1 ? 'piece' : 'pieces');
      const heroPrice = root.querySelector('[data-cro-single-total-price]');
      if (heroPrice) heroPrice.textContent = count ? money(total) : 'Choose individual pieces';

      if (singleMode) {
        const disabled = !count || !available || root.dataset.croDraftPreview === 'true';
        if (submit.disabled !== disabled) submit.disabled = disabled;
        if (submitLabel) submitLabel.textContent = count
          ? 'Add ' + count + ' ' + (count === 1 ? 'piece' : 'pieces') + ' to cart'
          : 'Select individual pieces';
      } else {
        if (submitLabel) submitLabel.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to Cart';
        const packageName = sheer && sheer.checked ? 'sheerpair' : complete && complete.checked ? 'setof4' : 'blackoutpair';
        const chosen = getVariant(selectedLength(), packageName);
        const disabled = root.dataset.croDraftPreview === 'true' || !chosen || !chosen.available;
        if (submit.disabled !== disabled) submit.disabled = disabled;
      }
      root.dispatchEvent(new CustomEvent('cro:bundle-change', { bubbles: true }));
    };

    const chooseVariant = () => {
      updatePrices();
      const option = sheer && sheer.checked ? 'sheerpair' : complete && complete.checked ? 'setof4' : 'blackoutpair';
      const desired = getVariant(selectedLength(), option);
      if (!desired) return;
      const picker = root.querySelector('variant-selects');
      if (!picker) return;
      const input = Array.from(picker.querySelectorAll('input[type="radio"]'))
        .find((candidate) => candidate.value === desired.title);
      const dropdown = picker.querySelector('select');
      if (input && !input.checked) input.click();
      else if (dropdown && dropdown.value !== desired.title) {
        dropdown.value = desired.title;
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    root.addEventListener('change', (event) => {
      if (sizes.includes(event.target)) {
        chooseVariant();
        updateSelection();
      } else if (event.target === complete || event.target === pair || event.target === sheer) {
        quantities.blackout = 0;
        quantities.sheer = 0;
        root.dataset.croPurchaseMode = 'set';
        chooseVariant();
        updateSelection();
      }
    });

    root.addEventListener('click', (event) => {
      const setCard = event.target.closest('.curtain-cro__choice-label');
      if (setCard && root.contains(setCard) && root.dataset.croPurchaseMode === 'single') {
        quantities.blackout = 0;
        quantities.sheer = 0;
        root.dataset.croPurchaseMode = 'set';
        window.setTimeout(() => { chooseVariant(); updateSelection(); }, 0);
        return;
      }
      const add = event.target.closest('[data-cro-single-kind]');
      const plus = event.target.closest('[data-cro-single-plus]');
      const minus = event.target.closest('[data-cro-single-minus]');
      const control = add || plus || minus;
      if (!control || !root.contains(control)) return;
      event.preventDefault();
      if (control.disabled) return;
      const kind = add ? add.dataset.croSingleKind : plus ? plus.dataset.croSinglePlus : minus.dataset.croSingleMinus;
      if (kind !== 'blackout' && kind !== 'sheer') return;
      const components = currentComponents();
      if (!components || !components[kind + 'SingleId'] || !components[kind + 'SingleAvailable']) return;
      if (add) quantities[kind] = 1;
      else if (plus) quantities[kind] += 1;
      else quantities[kind] = Math.max(0, quantities[kind] - 1);
      root.querySelectorAll('.curtain-cro__choice input[type="radio"]').forEach((input) => {
        input.checked = false;
      });
      root.dataset.croPurchaseMode = 'single';
      updateSelection();
    });

    root.addEventListener('submit', async (event) => {
      if (root.dataset.croPurchaseMode !== 'single' || event.target !== form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (root.dataset.croDraftPreview === 'true') return;
      updateSelection();
      if (submit.disabled) return;
      const components = currentComponents();
      if (!components) return;
      const items = [];
      if (quantities.blackout) items.push({ id: Number(components.blackoutSingleId), quantity: quantities.blackout });
      if (quantities.sheer) items.push({ id: Number(components.sheerSingleId), quantity: quantities.sheer });
      if (!items.length || items.some((item) => !item.id)) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const spinner = productForm && productForm.querySelector('.loading__spinner');
      if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
      submit.setAttribute('aria-disabled', 'true');
      submit.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      const payload = { items };
      if (cart && cart.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      try {
        const routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          const message = data.description || data.message || 'Unable to add these curtains to your cart.';
          if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage(message);
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'curtain-cro-single-pieces',
            productVariantId: items[0].id,
            cartData: data
          });
        }
        if (cart && cart.renderContents && data.sections) {
          try { cart.renderContents(data); }
          catch (renderError) {
            console.error('Curtain cart render failed after adding pieces:', renderError);
            window.location = (window.routes && window.routes.cart_url) || routeRoot + 'cart';
          }
        } else {
          window.location = (window.routes && window.routes.cart_url) || routeRoot + 'cart';
        }
      } catch (error) {
        console.error(error);
        if (productForm && productForm.handleErrorMessage) {
          productForm.handleErrorMessage('Unable to add these curtains to your cart. Please try again.');
        }
      } finally {
        submit.classList.remove('loading');
        submit.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      }
    }, true);

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || String(data.sectionId) !== String(root.dataset.section)) return;
        const variant = variants.find((entry) => String(entry.id) === String(data.variant && data.variant.id));
        if (!variant) return;
        const title = String(variant.title || '').toLowerCase().replace(/\s/g, '');
        const length = title.includes('4x9') ? '9' : '7';
        sizes.forEach((input) => { input.checked = input.value === length; });
        if (title.includes('1piece')) {
          root.dataset.croPurchaseMode = 'single';
          quantities.blackout = title.includes('blackout') ? 1 : 0;
          quantities.sheer = title.includes('sheer') ? 1 : 0;
        } else if (root.dataset.croPurchaseMode !== 'single') {
          pair.checked = title.includes('blackoutpair');
          if (sheer) sheer.checked = title.includes('sheerpair');
          if (complete) complete.checked = title.includes('setof4');
        }
        window.setTimeout(() => { updatePrices(); updateSelection(); }, 0);
      });
    }

    const initialInput = form.querySelector('[name="id"]');
    const initialVariant = variants.find((entry) => String(entry.id) === String(initialInput && initialInput.value));
    const initialTitle = String(initialVariant && initialVariant.title || '').toLowerCase().replace(/\s/g, '');
    if (initialTitle.includes('1piece')) {
      root.dataset.croPurchaseMode = 'single';
      quantities.blackout = initialTitle.includes('blackout') ? 1 : 0;
      quantities.sheer = initialTitle.includes('sheer') ? 1 : 0;
      root.querySelectorAll('.curtain-cro__choice input[type="radio"]').forEach((input) => {
        input.checked = false;
      });
      singlePanel && (singlePanel.open = true);
    }
    updatePrices();
    updateSelection();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetChoice, { once: true });
  } else {
    initSetChoice();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
